import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table"]

  connect() {
    document.getElementById('apply-registration-filters').addEventListener('click', this.applyFilters.bind(this))
  }
  
  applyFilters(event) {
    event.preventDefault()
    
    const eventId = document.getElementById('event_filter').value
    const filterProducts = document.getElementById('product_filter').checked
    
    const dataTable = $(this.tableTarget).DataTable()
    
    let url = new URL(dataTable.ajax.url(), window.location.origin)
    
    if (eventId) {
      url.searchParams.set('event_id', eventId)
    } else {
      url.searchParams.delete('event_id')
    }
    
    if (filterProducts) {
      url.searchParams.set('filter_products', 'true')
    } else {
      url.searchParams.delete('filter_products')
    }
    
    dataTable.ajax.url(url.toString()).load()
  }
}
